import "./App.css";
import "./common/styles/main.css";

import { FetchJson } from "./common/logic/Fetch";

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { Suspense, useState, useEffect } from "react";

import HomePage from "./pages/HomePage";
import GamePageMain from "./pages/game/GamePageMain";
import WinPage from "./pages/game/WinPage";

import TutorialPage from "./pages/game/TutorialPage";
import BrandingLogoWrapper from "../src/common/logos/BrandingLogoWrapper";

function Loading() {
  return (
    <div
      style={{
        background: "white",
        width: "100%",
        height: "100%",
        zIndex: 100,

        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* <div className="loading-bar">
       
        <div className="bar"></div>
      </div> */}

      <div className="spinner"></div>
    </div>
  );
}
function App() {
  return (
    <div className="App">
      <div className="page">
        {/* <BrandingLogoWrapper /> */}
        <Suspense fallback={<Loading />}>
          <BrowserRouter>
            <FetchJson>
              {/* game page */}
              {/* <GamePageMain /> */}
              {/* <HomePage/> */}
              {/* <Pages/> */}
              <Routes>
                {/* <Route path={process.env.PUBLIC_URL + "/"} element={<HomePage />} /> */}
                <Route
                  path={process.env.PUBLIC_URL + "/game"}
                  element={<GamePageMain />}
                />

                <Route
                  path={process.env.PUBLIC_URL + "/"}
                  element={<HomePage />}
                />

                <Route
                  path={process.env.PUBLIC_URL + "/win"}
                  element={<WinPage />}
                />

                <Route
                  path={process.env.PUBLIC_URL + "/tutorial"}
                  element={<TutorialPage />}
                />
              </Routes>
            </FetchJson>
          </BrowserRouter>
        </Suspense>
      </div>
    </div>
  );
}

export default App;
